<template>
    <div class="container-fluid no-min-height">
        <div class="row">
            <div class="col-12 col-lg-6 offset-lg-3">
                <h2 class="mb-2">{{ formData.title }}</h2>
                <div class="position-relative">
                    <transition name="fade">
                        <form v-if="!success" key="form">
                            <h3>Gegevens aanvrager</h3>
                            <TextInput
                                v-model="form.legalNames"
                                v-validate="'required'"
                                data-vv-as="Naam"
                                :disabled="processing"
                                :error="errors.first('legalNames')"
                                :name="'legalNames'"
                                label="Officiële voornamen en achternaam"
                                placeholder="Officiële voornamen en achternaam"
                            ></TextInput>
                            <DateInput
                                v-model="form.dateOfBirth"
                                v-validate="'required'"
                                data-vv-as="Geboortedatum"
                                :disabled="processing"
                                :error="errors.first('dateOfBirth')"
                                :name="'dateOfBirth'"
                                label="Geboortedatum"
                                placeholder="Geboortedatum"
                            ></DateInput>
                            <RadioInput
                                v-model="form.gender"
                                v-validate="'required'"
                                data-vv-as="Geslacht"
                                :options="[
                                    { name: 'Man', checked: true },
                                    { name: 'Vrouw', checked: false }
                                ]"
                                :disabled="processing"
                                :error="errors.first('gender')"
                                :name="'gender'"
                                label="Geslacht"
                                placeholder="Geslacht"
                            ></RadioInput>
                            <TextInput
                                v-model="form.phonenumber"
                                v-validate="{ required: true, digits: 10 }"
                                data-vv-as="Telefoonnummer"
                                :disabled="processing"
                                :error="errors.first('phonenumber')"
                                :name="'phonenumber'"
                                :max-length="10"
                                label="Telefoonnummer"
                                placeholder="0612345678 "
                            ></TextInput>
                            <TextInput
                                v-model="form.email"
                                v-validate="{ required: true, email: true }"
                                data-vv-as="E-mail"
                                :disabled="processing"
                                :error="errors.first('email')"
                                :name="'email'"
                                label="E-mailadres"
                                placeholder="naam@provider.com"
                            ></TextInput>

                            <h3 class="my-2">
                                Gegevens traject waarvoor je de verklaring
                                aanvraagt
                            </h3>

                            <TextInput
                                v-model="form.procedure"
                                v-validate="'required'"
                                data-vv-as="Traject"
                                :disabled="processing"
                                :error="errors.first('procedure')"
                                :name="'procedure'"
                                label="Traject"
                                placeholder="Traject"
                            ></TextInput>
                            <TextInput
                                v-model="form.diplomaYear"
                                v-validate="{ required: true, digits: 4 }"
                                data-vv-as="Jaar waarin je het traject hebt gevolgd"
                                :disabled="processing"
                                :error="errors.first('diplomaYear')"
                                :name="'diplomaYear'"
                                :max-length="4"
                                label="Jaar waarin je het traject hebt gevolgd"
                                placeholder="Jaar waarin je het traject hebt gevolgd"
                            ></TextInput>
                            <TextInput
                                v-model="form.location"
                                v-validate="'required'"
                                data-vv-as="Locatie"
                                :disabled="processing"
                                :error="errors.first('location')"
                                :name="'location'"
                                label="Locatie waar je het traject hebt gevolgd"
                                placeholder="Locatie waar je het traject hebt gevolgd"
                            ></TextInput>
                            <div class="col text-center">
                                <button
                                    class="btn btn-primary mb-1"
                                    :disabled="processing"
                                    @click.prevent="validateAndSubmit"
                                >
                                    Verstuur
                                </button>
                            </div>
                        </form>
                        <div
                            v-else
                            key="successMessage"
                            class="rte"
                            v-html="formData.successMessage"
                        ></div>
                    </transition>
                    <div
                        v-if="!success && error"
                        key="errorMessage"
                        class="rte form-failed"
                        v-html="errorMessageFromApi"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import FormSubmissionMixin from '@/js/mixins/form-submission-mixin.js';
import TextInput from '@/components/form/text-input';
import DateInput from '@/components/form/date-input';
import RadioInput from '@/components/form/radio-input';

Vue.use(VueReCaptcha, { siteKey: '6LfB5cMUAAAAAOnv1Nn1d1neosmH_X5xVuUx0zu4' });

export default {
    components: {
        TextInput,
        DateInput,
        RadioInput
    },

    mixins: [FormSubmissionMixin],

    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            form: {
                legalNames: '',
                dateOfBirth: '',
                gender: 'Man',
                phonenumber: '',
                email: '',
                procedure: '',
                diplomaYear: '',
                location: ''
            },
            postUrl: '/api/DiplomaStatementApi/Submit'
        };
    },
    computed: {
        errorMessageFromApi() {
            return this.errorMessage;
        }
    }
};
</script>

<style lang="scss"></style>
